const answerKey=(eventId)=>`amp-planner-answers-${eventId}`;

function readAnswers(eventId){
  try{
    return JSON.parse(
      localStorage.getItem(answerKey(eventId))||'{}'
    );
  }catch{
    return{};
  }
}

function countAnswers(answers){
  return Object.values(answers).filter((value)=>{
    if(Array.isArray(value))return value.length>0;
    if(value&&typeof value==='object'){
      return Object.values(value).some(Boolean);
    }
    return String(value||'').trim().length>0;
  }).length;
}

export function getSubmissionQueue(events){
  return events.map((event)=>{
    const answers=readAnswers(event.id);
    const answered=countAnswers(answers);
    const storedStatus=localStorage.getItem(
      `amp-planner-review-${event.id}`
    );
    const status=storedStatus||
      (event.status==='Approved'
        ?'Approved'
        :answered>0
          ?'Ready for review'
          :'Not started');

    return{
      ...event,
      answers,
      answered,
      status,
      submittedAt:localStorage.getItem(
        `amp-planner-submitted-${event.id}`
      )||''
    };
  }).filter((submission)=>submission.status!=='Not started');
}

export function markSubmissionReviewed(eventId,status){
  localStorage.setItem(
    `amp-planner-review-${eventId}`,
    status
  );
}

export function getReviewStatus(eventId,fallback){
  return localStorage.getItem(
    `amp-planner-review-${eventId}`
  )||fallback;
}

export function readSubmissionAnswers(eventId){
  return readAnswers(eventId);
}